import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hydrateWalletSuccess, persistWalletState, fetchWalletBalance } from '../../../../../store/walletSlice';
import { loadWalletFromStorage } from '../../../../../utils/wallet/walletUtils';

export function useWalletHydration() {
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.auth?.user?.companyId);
  const hydrated = useSelector((state) => state.wallet?.hydrated);
  const balanceFetched = useSelector((state) => state.wallet?.balanceFetched);
  const balanceLoading = useSelector((state) => state.wallet?.balanceLoading);
  const wallet = useSelector((state) => state.wallet);

  useEffect(() => {
    if (!hydrated) {
      const saved = loadWalletFromStorage(companyId);
      dispatch(hydrateWalletSuccess(saved));
    }
  }, [companyId, dispatch, hydrated]);

  useEffect(() => {
    if (companyId && !balanceFetched && !balanceLoading) {
      dispatch(fetchWalletBalance());
    }
  }, [companyId, balanceFetched, balanceLoading, dispatch]);

  useEffect(() => {
    if (hydrated) {
      dispatch(persistWalletState({ companyId }));
    }
  }, [wallet.alertPreferences, companyId, dispatch, hydrated]);
}
